import { TabPaneProps, Tabs } from 'antd'
import React, { useContext } from 'react'
import { useTranslation } from '@nic/commons'
import { RequestContext } from '../../../../../../Contexts/RequestContext'
import { ActionButtonHold, ActionButtonUpdate } from '../ActionButtons/ActionButtons'
import { ContactsContext } from '../../../../../../Providers/ContactsProvider'
import {
  ContactListFullDetailed,
  IDarwinContactExtended,
} from '../../../../../../ContactListFullDetailed/ContactListFullDetailed'
import { CandidateOrReferenceDetailCard } from './common'
import { NicScope } from '@nic/nic-api/types'
import { CandidateRegistrantContext } from '../../../../../../Providers/CandidateRegistrant'
import { useRegistrarPermissions } from '../../../../../../Hooks/useRegistrarPermissions'
import { useRouter } from '../../../../../../Hooks/useRouter'

const { TabPane } = Tabs

export function ContactsToDeleteTab(props: TabPaneProps) {
  const t = useTranslation()
  const {
    state: { toDelete, loading },
    actions,
    dispatch,
  } = useContext(ContactsContext)
  const { state: stateCandidate } = useContext(CandidateRegistrantContext)
  const { stateReqAnomalies, scope, id, stateReqById } = useContext(RequestContext)
  const { hasRegistrarNotProcessRequestPermission } = useRegistrarPermissions()
  const isRegistrar = scope === 'registrar'
  const isPending = stateReqById.data?.status === 'pending'
  const router = useRouter()
  //console.log('Contacts toDelete', toDelete)

  const Actions = (record: IDarwinContactExtended) => {
    return [
      <ActionButtonUpdate
        key={'b_update'}
        onClick={() => {
          //console.log('acrion', record, id)
          id && actions.changeContactAction(id, record.darwinId, 'todo', scope)(dispatch)
        }}
        disabled={!isPending || !isRegistrar || hasRegistrarNotProcessRequestPermission}
      />,
      <ActionButtonHold
        key={'b_hold'}
        onClick={() => {
          // console.log('acrion', record, id)
          id && actions.changeContactAction(id, record.darwinId, 'hold', scope)(dispatch)
        }}
        disabled={!isPending || !isRegistrar || hasRegistrarNotProcessRequestPermission}
      />,
    ]
  }

  const MemoizedContactListFullDetailed = React.memo(ContactListFullDetailed)

  const onChangePageHandler = (page?: number, pageSize?: number) => {
    router.pushHelper({ page: page, size: pageSize })
    actions.getContacts(id, 'delete', page, pageSize, scope)(dispatch)
  }

  return (
    <TabPane
      tab={t('contactsToDeleteTab.tabTitle', { count: toDelete.page.totalElements })}
      key={props.tabKey}
    >
      <MemoizedContactListFullDetailed
        readonly={stateReqById.data?.status === 'completed'}
        contacts={toDelete}
        contactDetailTitle={t('contactsToDeleteTab.contactDetailTitle')}
        anomalies={stateReqAnomalies.data}
        scope={scope}
        domainContactDetailTitle={t('contactsToDeleteTab.domainContactDetailTitle')}
        actionColumn={Actions}
        loading={loading}
        onChangePagination={onChangePageHandler}
        showAdditionalContactDetailCard
        additionalContactDetailCard={
          <CandidateOrReferenceDetailCard
            candidateContact={stateCandidate.data}
            scope={scope as NicScope}
          />
        }
      />
    </TabPane>
  )
}
